import { SubmittalProps } from "@/interfaces/submittal_types";
import { TaskProps } from "@/interfaces/tasks_types";
import { CategoryCounts } from "../ProjectRow";

export const calculateCategoryCounts = (type: TaskProps[] | SubmittalProps[]): CategoryCounts => {
    const counts = {
        Mechanical: { total: 0, completed: 0 },
        Electrical: { total: 0, completed: 0 },
        Plumbing: { total: 0, completed: 0 },
        "Fire Protection": { total: 0, completed: 0 },
        Other: { total: 0, completed: 0 }
    }

    type.forEach(task => {
        if (task.category.toLocaleLowerCase() === "fire protection") {
            counts["Fire Protection"].total++;
            if (task.status === "Closed") {
                counts["Fire Protection"].completed++;
            }
        } else {
            const category = task.category as keyof typeof counts
            if (category in counts) {
                counts[category].total++;
                if (task.status === "Closed") {
                    counts[category].completed++;
                }
            } else {
                counts.Other.total++;
                if (task.status === "Closed") {
                    counts.Other.completed++;
                }
            }
        }
    })

    return counts;
};
